import { render, staticRenderFns } from "./AigcCheck.vue?vue&type=template&id=5b8291f6&scoped=true"
import script from "./AigcCheck.vue?vue&type=script&lang=js"
export * from "./AigcCheck.vue?vue&type=script&lang=js"
import style0 from "./AigcCheck.vue?vue&type=style&index=0&id=5b8291f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8291f6",
  null
  
)

export default component.exports